import React from "react";

const CustomCheckbox = ({
  title,
  description,
  checked,
  setOptional,
  optional,
  optionNone,
}) => {
  const handleClick = () => {
    if (optionNone) {
      if (checked) {
        setOptional([]);
      } else {
        setOptional([title]);
      }
      return;
    }
    if (checked) {
      const newOptional = optional.filter(
        (el) => el !== title && el !== "Nej, tack!"
      );
      setOptional(newOptional);
    } else {
      const newOptional = optional.filter((el) => el !== "Nej, tack!");
      setOptional([...newOptional, title]);
    }
  };

  return (
    <div
      className="rounded-md border border-gray-300 px-8 py-6 cursor-pointer relative mb-6 flex items-center justify-between"
      style={{
        borderColor: checked ? "#011E41" : "rgb(209,213,219)",
      }}
      onClick={handleClick}
      aria-hidden="true"
    >
      <div className="w-9/12">
        <div
          className={
            "text-lg text-main-600 mb-1  " + (checked ? " font-semibold" : "")
          }
        >
          {title}
        </div>
        <div className="text-sm text-gray-500" style={{ lineHeight: "24px" }}>
          {description}
        </div>
      </div>
      <div
        className="rounded-full border w-6 h-6 mr-3 flex items-center justify-center"
        style={{
          borderColor: checked ? "#011E41" : "rgb(209,213,219)",
        }}
        // onClick={(e) => {
        //   e.stopPropagation();
        // }}
        aria-hidden="true"
      >
        {checked && (
          <div
            className="w-4 h-4 rounded-full"
            style={{ background: "#011E41" }}
          ></div>
        )}
      </div>
    </div>
  );
};

export default CustomCheckbox;
